export const getTimeOnItemSeconds = (
	itemViewedTimestamps: Map<number, string> | undefined,
	itemId: number,
): number | undefined => {
	const itemViewedAt = itemViewedTimestamps?.get(itemId);
	if (!itemViewedAt) {
		return undefined;
	}
	return Math.max(
		0,
		Math.round((Date.now() - new Date(itemViewedAt).getTime()) / 1000),
	);
};
